import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Typography,
  TextField,
  Paper,
  Button,
  IconButton,
  Tooltip,
  Stack,
  useTheme,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/global/utils";
import CircularProgress from "@mui/material/CircularProgress";
import {
  resetTrackingData,
  Attendance,
  AttendanceProcess,
  MonthlyAttendance,
} from "../../../store/reducers/Formapireducer";
import useMediaQuery from "@mui/material/useMediaQuery";
import { GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { Formik } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { DataGrid } from "@mui/x-data-grid";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../../Theme";
import { useDispatch } from "react-redux";
import { PDFDownloadLink } from "@react-pdf/renderer";
import AttendancePDF from "../../reports/AttendancePdf";
import { toast } from "react-hot-toast";
import { Employeeautocomplete } from "../../../ui-components/global/Autocomplete";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DailyattendancePDF from "../../reports/Dailyattendancepdf";
import { getConfig } from "../../../config";
import DailyAttendanceExcel from "../../reports/DailyAttendanceExcel";
import { FaFileExcel, FaFileImport, FaDownload } from "react-icons/fa";



const EditdailyAttendance = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const isManager = sessionStorage.getItem("isManager");
  console.log(isManager, "--isManager");

  var recID = params.id;
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const EmpName = sessionStorage.getItem("EmpName");
  const CompanyID = sessionStorage.getItem("companyId");

  const AttendanceData = useSelector(
    (state) => state.formApi.MonthlyAttendanceData
  );
  const AttendanceDailyloading = useSelector(
    (state) => state.formApi.AttendanceDailyloading
  );
  console.log("AttendanceData", AttendanceData);
  const [eventsData, setEventsData] = useState([]);
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const data = useSelector((state) => state.formApi.Data);
  const isLoading = useSelector((state) => state.formApi.loading);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = React.useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [show, setScreen] = React.useState("0");
  const [footerHeight, setFooterHeight] = useState(60);
  const [isReady, setIsReady] = useState(false);
  const EMPID = sessionStorage.getItem("EmpId");
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const colors = tokens(theme.palette.mode);
  const currentDate = new Date().toISOString().split("T")[0];
  const [errorMsgData, setErrorMsgData] = useState(null);
  const HeaderImg = sessionStorage.getItem("CompanyHeader");
  const FooterImg = sessionStorage.getItem("CompanyFooter");
  console.log("HeaderImg", HeaderImg, FooterImg);
  const config = getConfig();
  const baseurlUAAM = config.UAAM_URL;
  useEffect(() => {
    if (!FooterImg) return;

    const url = `${baseurlUAAM}/uploads/images/${FooterImg}`;

    const img = new Image();
    img.src = url;

    img.onload = () => {
      const aspectRatio = img.height / img.width;

      const pageWidth = 595;
      const MAX_FOOTER_HEIGHT = 80; // 🔥 IMPORTANT

      const calculatedHeight = Math.min(
        pageWidth * aspectRatio,
        MAX_FOOTER_HEIGHT
      );

      setFooterHeight(calculatedHeight);
      setIsReady(true);
    };
  }, [FooterImg]);
  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);
  useEffect(() => {
    dispatch(resetTrackingData());
    // dispatch(MonthlyAttendance({
    //     Date: currentDate,
    //     ManagerID: EMPID,
    //     Self: useCurrentEmp ? "Y" : "N",
    // }));
  }, []);

  const [dailyuseCurrentEmp, setdailyUseCurrentEmp] = useState(isManager != 1);
  console.log(dailyuseCurrentEmp, "--outside useEffect dailyuseCurrentEmp");

  useEffect(() => {
    if (!EMPID) return;
    console.log("--calling UseEffect");
    console.log(dailyuseCurrentEmp, "--inside useEffect dailyuseCurrentEmp");

    const savedSelf = sessionStorage.getItem("dailyuseCurrentEmp");
    const savedDate = sessionStorage.getItem("date");
    console.log(savedSelf, "--savedSelf");
    const self = savedSelf === "true";
    const restoredDate = savedDate || new Date().toISOString().split("T")[0];

    setdailyUseCurrentEmp(self);

    const data = {
      Date: restoredDate,
      ManagerID: EMPID,
      Self: self ? "Y" : "N",
      CompanyID
    };

    console.log("Dispatching MonthlyAttendance:", data);
    dispatch(MonthlyAttendance({ data }));
  }, [EMPID, dispatch]);


  //For bulk Upload - Excel

  const fileInputRef = useRef(null);
  const [selectedMonth, setSelectedMonth] = useState("");

  // const getMonthFromDate = (dateString) => {
  //   const monthNumber = parseInt(dateString.split("-")[1], 10); // "03" → 3
  //   return monthNumber;
  // };
  // const getMonthShort = (monthNumber) => {
  //   return new Date(0, monthNumber - 1).toLocaleString("en-US", {
  //     month: "short",
  //   });
  // };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // if (!month) {
    //   alert("Please select month");
    //   return;
    // }

    //  Convert "2026-03-20" → Mar
    // const monthName = new Date(month).toLocaleString("en-US", {
    //   month: "short",
    // });

    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();

    const dateKey = `${year}${month}${day}`;

    //  File name for API
    const fileName = `Attendance_Daily_${dateKey}`;

    try {
      const formData = new FormData();

      //  Match API keys exactly
      formData.append("excel_file", file);
      formData.append("Type", "bulk_process");
      formData.append("file_name", fileName);
      formData.append("SubType", "D");

      console.log("Sending Data:", {
        excel_file: file.name,
        Type: "bulk_process",
        file_name: fileName,
        SubType: "D"
      });

      const response = await fetch(
        "https://essuat.beyondexs.com/api/BulkAttendanceProcess/Attendance_Bulk_Processor.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      console.log("API Response:", result);

      if (result?.Status === "Y") {
        alert("Attendance uploaded successfully ");
      } else {
        alert(result?.message || "Upload failed");
      }

    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong");
    }

    //  Reset input (important)
    e.target.value = null;
  };


  //For Download Process
  const handleDownload = async () => {
    try {
      const response = await fetch(
        "https://essuat.beyondexs.com/api/BulkAttendanceProcess/ExcelFileDownload.php?file=Attendance_Daily.xlsx",
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Attendance_Daily.xlsx"); // file name

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download file");
    }
  };

  function AttendanceTool() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography>Attendance</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }

  const AttColumn = [
    // {
    //     field: "SLNO",
    //     headerName: "SL#",
    //     width: "50",
    //     renderCell: (params) => (
    //         <div style={{ textAlign: "right" }}>{params.value}</div>
    //     ),
    // },
    // {
    //     field: "slno",
    //     headerName: "SL#",
    //     width: 50,
    //     sortable: false,
    //     filterable: false,
    //     valueGetter: (params) =>
    //         `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`
    // },
    {
      field: "slno",
      headerName: "SL#",
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();

        if (totalVisibleRows < totalAllRows) {
          return index + 1;
        } else {
          return page * pageSize + index + 1;
        }
      },
    },
    {
      field: "Name",
      headerName: "Personnel",
      flex: 1.5,
      headerAlign: "center",
    },
    {
      field: "ShiftName1",
      headerName: "Shift Name 1",
      flex: 1,
      headerAlign: "center",

    },
    // {
    //   field: "ShiftName2",
    //   headerName: "Shift Name 2",
    //   flex: 1,
    //   headerAlign: "center",

    // },

    {
      field: "EmplyeeCheckInDateTime",
      headerName: "In Time",
      flex: 1,
      headerAlign: "center",

    },
    {
      field: "EmplyeeCheckOutDateTime",
      headerName: "Out Time",
      flex: 1,
      headerAlign: "center",

    },
    {
      field: "NumberOfHoursWorked",
      headerName: "Worked Hours",
      flex: 1,
      headerAlign: "center",

    },
    {
      field: "Permission",
      headerName: "Permission (In Minutes)",
      flex: 1,
      headerAlign: "center",

    },
    {
      field: "Status",
      headerName: "Status",
      flex: 1,
      headerAlign: "center",

    },
  ];

  /***********Attendance ************/

  const currentMonthNumber = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();
  const AttInitialvalues = {
    date: sessionStorage.getItem("date") || new Date().toISOString().split("T")[0],
  };
  const attendaceFnSave = async (values) => {
    const data = {
      Date: values.date,
      ManagerID: EMPID,
      Self: dailyuseCurrentEmp ? "Y" : "N",
      CompanyID
    };

    console.log(data, "=====DATA");
    dispatch(MonthlyAttendance({ data }));
    setPage(0);
    // setButtonVisible(true)
  };

  const exploreLoading = useSelector((state) => state.exploreApi.loading);

  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") navigate("/");
        if (props === "Close") navigate("/Apps/Chart");
      }
    });
  };
  const [empData, setempData] = useState(null);
  const handleSelectionEmployeeChange = (newValue) => {
    if (newValue) {
      setempData(newValue);
      console.log(newValue.RecordID, "--selectedproductid");
    } else {
      setempData(null);
    }
    setdailyUseCurrentEmp(false);
  };

  return (
    <React.Fragment>
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0", height: "40px" }}>
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Typography variant="h3" sx={{ marginLeft: "10px", fontSize: "19px",color:"#0000D1"}}>Daily Attendance</Typography>
          </Box>
          <Box display="flex">
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      <Paper elevation={3} sx={{ margin: "10px" }}>
        <Formik
          initialValues={AttInitialvalues}
          enableReinitialize={true}
          onSubmit={(values, { resetForm }) => {
            setTimeout(() => {
              attendaceFnSave(values, resetForm);
            }, 100);
          }}
        >
          {({
            errors,
            touched,
            handleBlur,
            handleChange,
            isSubmitting,
            values,
            handleSubmit,
            resetForm,
            setFieldValue
          }) => (
            <form
              onSubmit={handleSubmit}
              onReset={() => {
                resetForm();
                sessionStorage.removeItem("dailyuseCurrentEmp");
                setdailyUseCurrentEmp(false);
                setFieldValue("date", new Date().toISOString().split("T")[0])
                sessionStorage.removeItem("date")
                dispatch(resetTrackingData());
              }}
            >
              <Box
                display="grid"
                gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                gap={formGap}
                padding={1}
                sx={{
                  "& > div": {
                    gridColumn: isNonMobile ? undefined : "span 4",
                  },
                }}
              >
                <Stack direction="row" spacing={2}>
                  <TextField
                    name="date"
                    type="date"
                    id="date"
                    label="Date"
                    variant="standard"
                    focused
                    inputFormat="YYYY-MM-DD"
                    value={values.date}
                    onBlur={handleBlur}
                    // onChange={handleChange}
                    onChange={(e) => {
                      handleChange(e);
                      sessionStorage.setItem("date", e.target.value);
                    }}
                    error={!!touched.date && !!errors.date}
                    helperText={touched.date && errors.date}
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      "& .MuiFilledInput-root": {
                        backgroundColor: "transparent", // optional: adjust if needed
                      },
                      width: 200,
                    }}
                    inputProps={{ max: new Date().toISOString().split("T")[0] }}
                  />
                  {/* {isManager === "1" ? (
                    <>
                      <Employeeautocomplete
                        sx={{ width: 400 }}
                        name="Employee"
                        label="Employee"
                        id="Employee"
                        value={empData}
                        onChange={handleSelectionEmployeeChange}
                        url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${companyID}}}`}
                      />
                    </>
                  ) : (
                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      id="emp"
                      name="year"
                      label="Employee Name"
                      value={EmpName}
                      inputProps={{ min: "1900", max: "2100", step: "1" }}
                      focused
                      onChange={handleChange}
                      onBlur={handleBlur}
                      sx={{
                        "& .MuiFilledInput-root": {
                          backgroundColor: "transparent",
                        },
                        width: 400,
                      }}
                    />
                  )}
                    <FormControlLabel
          control={
            <Checkbox
              checked={useCurrentEmp}
              onChange={(e) => { setUseCurrentEmp(e.target.checked);
                setempData(null)}}
              color="primary"
            />
          }
          label="Self"
        /> */}
                  {/* {isManager == "1" && (
                                        <Employeeautocomplete
                                            sx={{ width: 400 }}
                                            name="Employee"
                                            label="Employee"
                                            id="Employee"
                                            value={empData}
                                            onChange={handleSelectionEmployeeChange}
                                            url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${companyID}}}`}
                                        />
                                    )} */}

                  {/* <FormControlLabel
                                        control={
                                            <Checkbox
                                                as={Checkbox}
                                                checked={useCurrentEmp}
                                                onChange={(e) => {
                                                    setUseCurrentEmp(e.target.checked);
                                                    setempData(null);
                                                }}
                                                color="primary"
                                            />
                                        }
                                        label="Self"
                                    /> */}
                  {/* <FormControlLabel
                    control={
                      <Checkbox
                        checked={useCurrentEmp}
                        onChange={(e) => {
                          // Allow toggle only if manager
                          if (isManager === "1") {
                            setUseCurrentEmp(e.target.checked);
                            setempData(null);
                          }
                        }}
                        color="primary"
                      />
                    }
                    label="Self"
                  /> */}
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={dailyuseCurrentEmp}
                        onChange={(e) => {
                          if (isManager === "1" || isManager === "0") {
                            const checked = e.target.checked;
                            setdailyUseCurrentEmp(checked);

                            sessionStorage.setItem("dailyuseCurrentEmp", checked);

                            if (checked) {
                              setempData(null);
                              sessionStorage.removeItem("empData"); // clear old empData
                            }
                          }
                        }}
                        color="primary"
                      />
                    }
                    label="Self"
                  />

                </Stack>
                <Stack
                  direction="row"
                  spacing={2}
                  display="flex"
                  padding={1}
                  justifyContent="end"
                >
                  <Button type="submit" variant="contained" color="secondary">
                    APPLY
                  </Button>
                  <Button type="reset" variant="contained" color="error">
                    RESET
                  </Button>
                  {/* {isManager === "1" && AttendanceData?.length > 0 && (
                    <PDFDownloadLink
                      document={
                        <DailyattendancePDF
                          data={AttendanceData}
                          filters={{
                            // Month: values.month,
                            // Year: values.year,
                            Date: values.date,
                            Self: dailyuseCurrentEmp ? "Y" : "N",
                            Date: values.date,
                            EmployeeID: empData?.Name || EmpName,
                            HeaderImg: HeaderImg,
                            FooterImg: FooterImg,
                            Imageurl: baseurlUAAM
                          }}
                          footerHeight={footerHeight}
                        />
                      }
                      fileName={`Attendance_Report_${empData?.Name || "Employee"
                        }.pdf`}
                      style={{ color: "#d32f2f", cursor: "pointer" }}
                    >
                      {({ loading }) =>
                        loading ? (
                          <PictureAsPdfIcon
                            sx={{ fontSize: 24, opacity: 0.5 }}
                          />
                        ) : (
                          <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                        )
                      }
                    </PDFDownloadLink>
                  )}
                  {isManager === "1" && AttendanceData?.length > 0 && (

                    <FaFileExcel
                      size={20}
                      color="#1D6F42"
                      style={{ cursor: "pointer", }}
                      onClick={() =>
                        DailyAttendanceExcel(
                          AttendanceData,
                          {
                            Date: values.date,
                            Self: dailyuseCurrentEmp ? "Y" : "N",
                            Date: values.date,
                            EmployeeID: empData?.Name || EmpName,
                            HeaderImg: HeaderImg,
                            FooterImg: FooterImg,
                            Imageurl: baseurlUAAM
                          }
                          // { month: values.month, year: values.year },
                          // empData
                        )
                      }
                    />

                  )} */}
                  {AttendanceDailyloading ? (
                    <CircularProgress size={22} />
                  ) : (
                    <>
                      {/* PDF */}
                      {isManager === "1" && AttendanceData?.length > 0 && (
                        <PDFDownloadLink
                          document={
                            <DailyattendancePDF
                              data={AttendanceData}
                              filters={{
                                Date: values.date,
                                Self: dailyuseCurrentEmp ? "Y" : "N",
                                EmployeeID: empData?.Name || EmpName,
                                HeaderImg: HeaderImg,
                                FooterImg: FooterImg,
                                Imageurl: baseurlUAAM,
                              }}
                              footerHeight={footerHeight}
                            />
                          }
                          fileName={`Attendance_Report_${empData?.Name || "Employee"
                            }.pdf`}
                          style={{ color: "#d32f2f", cursor: "pointer" }}
                        >
                          {({ loading }) =>
                            loading ? (
                              <PictureAsPdfIcon
                                sx={{ fontSize: 24, opacity: 0.5 }}
                              />
                            ) : (
                              <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                            )
                          }
                        </PDFDownloadLink>
                      )}

                      {/* Excel */}
                      {isManager === "1" && AttendanceData?.length > 0 && (
                        <FaFileExcel
                          size={20}
                          color="#1D6F42"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            DailyAttendanceExcel(AttendanceData, {
                              Date: values.date,
                              Self: dailyuseCurrentEmp ? "Y" : "N",
                              EmployeeID: empData?.Name || EmpName,
                              HeaderImg: HeaderImg,
                              FooterImg: FooterImg,
                              Imageurl: baseurlUAAM,
                            })
                          }
                        />
                      )}
                    </>
                  )}

                  <FaFileImport
                    size={20}
                    title="Import"
                    color="#1D6F42"
                    style={{ cursor: "pointer" }}
                    onClick={() => fileInputRef.current.click()}
                  />

                  <input
                    type="file"
                    accept=".xlsx,.xls"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={(e) => handleFileUpload(e)}
                  />

                  <FaDownload
                    size={20}
                    title="download"
                    cursor='pointer'
                    onClick={handleDownload}
                  />
                </Stack>
              </Box>
              <Box sx={{ gridColumn: "span 4" }}>
                <Box
                  height="500px"
                  // height={dataGridHeight}
                  marginTop={2}
                  sx={{
                    "& .MuiDataGrid-root": {
                      // border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      // borderBottom: "none",
                    },
                    "& .name-column--cell": {
                      color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[800],
                      // borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      // borderTop: "none",
                      backgroundColor: colors.blueAccent[800],
                    },
                    "& .MuiCheckbox-root": {
                      color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .odd-row": {
                      backgroundColor: "",
                      color: "", // Color for odd rows
                    },
                    "& .even-row": {
                      backgroundColor: "#d0edec",
                      color: "", // Color for even rows
                    },
                  }}
                >
                  <DataGrid
                    sx={{
                      "& .MuiDataGrid-footerContainer": {
                        height: dataGridHeaderFooterHeight,
                        minHeight: dataGridHeaderFooterHeight,
                      },
                    }}
                    rowHeight={dataGridRowHeight}
                    headerHeight={dataGridHeaderFooterHeight}
                    rows={AttendanceData}
                    columns={AttColumn}
                    disableSelectionOnClick
                    getRowId={(row) => row.SLNO}
                    pageSize={pageSize}
                    page={page}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onPageChange={(newPage) => setPage(newPage)}
                    onCellClick={(params) => { }}
                    rowsPerPageOptions={[5, 10, 20]}
                    pagination
                    components={{
                      Toolbar: AttendanceTool,
                    }}
                    onStateChange={(stateParams) =>
                      setRowCount(stateParams.pagination.rowCount)
                    }
                    loading={AttendanceDailyloading}
                    componentsProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "odd-row"
                        : "even-row"
                    }
                  />
                </Box>
              </Box>
            </form>
          )}
        </Formik>
      </Paper>
    </React.Fragment>
  );
};

export default EditdailyAttendance;
